import { ReactElement } from 'react'
import { Delete, DragIndicator } from '@mui/icons-material'
import { IconButton, TableCell, TableRow, Typography } from '@mui/material'
import type { ShearConnectionDTO } from '@api/fastAPI.schemas'
import { DraggableProvided } from '@hello-pangea/dnd'
import { Box } from '@ui/structure'
import { formatShearDistance, formatShearResistance } from '../../../constants'

interface Props {
  prio: number
  connection: ShearConnectionDTO
  provided: DraggableProvided
  isDragging: boolean
  onDelete: () => void
}

const ListItem = ({ prio, connection, provided, isDragging, onDelete }: Props): ReactElement => {
  const { name, short_name, guid, export_comment, distance, r_d_wind, r_d_earthquake } = connection

  return (
    <TableRow
      ref={provided.innerRef}
      {...provided.draggableProps}
      key={guid}
      sx={({ shadows }) => ({
        ...provided.draggableProps.style,
        width: '100%',
        display: isDragging ? 'table' : 'table-row',
        background: '#fff',
        boxShadow: isDragging ? shadows[1] : 'none',
      })}
    >
      <TableCell component="th" scope="row">
        <Box display="flex" alignItems="center">
          <Box mr={2} mt={0.5} {...provided.dragHandleProps}>
            <DragIndicator fontSize="small" />
          </Box>
          <Typography>{prio}</Typography>
        </Box>
      </TableCell>

      <TableCell>{name}</TableCell>
      <TableCell>{short_name}</TableCell>
      <TableCell>{export_comment}</TableCell>
      <TableCell>{formatShearDistance(distance)}</TableCell>
      <TableCell>{formatShearResistance(r_d_earthquake)}</TableCell>
      <TableCell>{formatShearResistance(r_d_wind)}</TableCell>
      <TableCell align="right">
        <Box display="flex" justifyContent="flex-end">
          <IconButton size="small" onClick={onDelete}>
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      </TableCell>
    </TableRow>
  )
}

export default ListItem
